import axios from 'axios';
import { API_URL } from '../config/data';

// Функция для получения токена из localStorage
export const getAuthToken = () => {
  return localStorage.getItem('authToken');
};

// Функция для проверки авторизации
export const checkAuth = () => {
  const token = getAuthToken();
  if (!token) {
    // Очищаем localStorage и перенаправляем на страницу входа
    localStorage.removeItem('authToken');
    localStorage.removeItem('userData');
    window.location.href = '/login';
    return false;
  }
  return true;
};

// Функция для проверки авторизации админа
export const checkAdminAuth = () => {
  const token = localStorage.getItem('token');
  if (!token) {
    // Очищаем localStorage и перенаправляем на страницу входа админа
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.location.href = '/admin/login';
    return false;
  }
  return true;
};

// Функция для обработки ошибок авторизации
export const handleAuthError = (error) => {
  console.error('Ошибка авторизации:', error);
  
  // Если ошибка 401 (Unauthorized) или 403 (Forbidden)
  if (error.response?.status === 401 || error.response?.status === 403) {
    // Очищаем localStorage и перенаправляем на страницу входа
    localStorage.removeItem('authToken');
    localStorage.removeItem('userData');
    window.location.href = '/login';
    return true;
  }
  
  // Если ошибка сети или другая ошибка
  if (!error.response) {
    // Очищаем localStorage и перенаправляем на страницу входа
    localStorage.removeItem('authToken');
    localStorage.removeItem('userData');
    window.location.href = '/login';
    return true;
  }
  
  return false;
};

// Функция для обработки ошибок авторизации админа
export const handleAdminAuthError = (error) => {
  console.error('Ошибка авторизации админа:', error);
  
  // Если ошибка 401 (Unauthorized) или 403 (Forbidden)
  if (error.response?.status === 401 || error.response?.status === 403) {
    // Очищаем localStorage и перенаправляем на страницу входа админа
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.location.href = '/admin/login';
    return true;
  }
  
  // Если ошибка сети или другая ошибка
  if (!error.response) {
    // Очищаем localStorage и перенаправляем на страницу входа админа
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.location.href = '/admin/login';
    return true;
  }
  
  return false;
};

// Функция для выхода из системы
export const logout = async () => {
  try {
    const token = getAuthToken();
    
    if (token) {
      // Отправляем запрос на сервер для выхода
      await axios.post(`${API_URL}/api/auth/logout`, {}, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
    }
  } catch (error) {
    console.error('Ошибка при выходе из системы:', error);
    // Продолжаем выполнение даже если запрос на сервер не удался
  } finally {
    // Очищаем локальные данные
    localStorage.removeItem('authToken');
    localStorage.removeItem('userData');
    
    // Перенаправляем на страницу входа
    window.location.href = '/login';
  }
};

// Функция для входа админа
export const loginAdmin = async (email, password) => {
  try {
    const response = await axios.post(`${API_URL}/api/auth/login`, {
      email,
      password
    });
    
    const { token, user } = response.data;
    
    // Проверяем, что пользователь является админом
    if (!user.is_verified) {
      throw new Error('У вас нет прав доступа к админ-панели');
    }
    
    // Сохраняем токен и данные пользователя
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(user));
    
    return { token, user };
  } catch (error) {
    console.error('Ошибка входа админа:', error);
    throw error;
  }
};

// Функция для выхода из системы админа
export const logoutAdmin = async () => {
  try {
    const token = localStorage.getItem('token');
    
    if (token) {
      // Отправляем запрос на сервер для выхода
      await axios.post(`${API_URL}/api/auth/logout`, {}, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
    }
  } catch (error) {
    console.error('Ошибка при выходе из системы админа:', error);
    // Продолжаем выполнение даже если запрос на сервер не удался
  } finally {
    // Очищаем локальные данные
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    
    // Перенаправляем на страницу входа админа
    window.location.href = '/admin/login';
  }
};